export default __webpack_public_path__ + "static/icon3@2x-b5e8388602e30d903e0dfcb17aab945c.png";